import { useState, type FC } from 'react';
import { useNavigate } from 'react-router';

import { Button, Space, Text } from '@g2u/ui-kit';

import { useTechTickets } from '../hooks/useTechTickets';
import { CreateTicketModal, TicketList } from 'components';
import styles from '../edit.module.scss';
import { Select } from 'antd';

type Props = Readonly<{
  technicianId?: string;
}>;

export const TechnicianTickets: FC<Props> = (props) => {
  const navigate = useNavigate();
  const { technicianId } = props;
  const [status, setStatus] = useState<'0' | '1' | null>(null);
  const { tickets, paginationMetadata, isTicketsLoading } = useTechTickets(status, technicianId);
  const [isCreateModalOpen, setCreateModalOpen] = useState<boolean>();

  return (
    <>
      <title>Technician Tickets</title>
      <Space.$
        direction={Space.Direction.Vertical}
        size={Space.Size.ExtraLarge}
        fullWidth
        className={styles.edit__content}
      >
        <Space.$ justify={Space.Justify.SpaceBetween}>
          <span>
            <Text.$>Status : </Text.$>
            <Select
              style={{ width: 150 }}
              defaultValue={null}
              options={[
                {
                  label: 'All',
                  value: null,
                },
                {
                  label: 'Open',
                  value: '1',
                },
                {
                  label: 'Closed',
                  value: '0',
                },
              ]}
              onChange={(val) => setStatus(val)}
            />
          </span>
        </Space.$>
        <TicketList
          tickets={tickets}
          paginationMetadata={paginationMetadata}
          isLoading={isTicketsLoading}
          onAdd={() => setCreateModalOpen(true)}
          hideColumns={['technician']}
          footer={
            <Button.$
              dataTestId="open-all-tickets"
              onClick={() =>
                navigate(`/tasks/tickets?search_type=technician_id&search_value=${technicianId}&status=${status || ''}`)
              }
            >
              Open all
            </Button.$>
          }
        />
      </Space.$>
      <CreateTicketModal
        technicianId={technicianId}
        isOpen={!!isCreateModalOpen}
        onClose={() => setCreateModalOpen(false)}
      />
    </>
  );
};
